var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDwelltimeOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1.5,
    width: 52,
    height: 53,
    rx: 6.5,
    fill: "#FF8027"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1.5,
    width: 52,
    height: 53,
    rx: 6.5,
    stroke: "#FF8027",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.6046 38.6046C36.5072 40.7027 33.8347 42.1316 30.9252 42.7106C28.0156 43.2897 24.9997 42.9928 22.2589 41.8576C19.518 40.7224 17.1754 38.7999 15.5273 36.3332C13.8792 33.8665 12.9997 30.9664 13 27.9998H14.875C14.8754 30.5951 15.6453 33.132 17.0874 35.2898C18.5295 37.4475 20.579 39.1292 22.9769 40.1222C25.3747 41.1152 28.0131 41.3749 30.5585 40.8685C33.1039 40.3621 35.442 39.1123 37.2772 37.2771C39.1123 35.442 40.3621 33.1039 40.8685 30.5585C41.3749 28.0131 41.1152 25.3746 40.1222 22.9768C39.1292 20.579 37.4475 18.5295 35.2897 17.0874C33.132 15.6453 30.5951 14.8754 27.9998 14.875V19.9724H26.1248V13H27.9998C30.9664 12.9997 33.8665 13.8792 36.3332 15.5272C38.8 17.1753 40.7225 19.5179 41.8577 22.2588C42.9929 24.9997 43.2898 28.0156 42.7107 30.9252C42.1317 33.8348 40.7027 36.5072 38.6046 38.6046V38.6046ZM31.3267 27.7994C31.3267 28.7953 30.9311 29.7503 30.2269 30.4545C29.5228 31.1586 28.5677 31.5542 27.5719 31.5542C26.5761 31.5542 25.6211 31.1586 24.9169 30.4545C24.2128 29.7503 23.8172 28.7953 23.8172 27.7994C23.8172 27.7767 23.8234 27.7558 23.8238 27.7332L14.875 25.2174L15.3825 23.42L24.3296 25.9377C24.7385 25.2187 25.374 24.6555 26.1368 24.3358C26.8995 24.0162 27.7467 23.9582 28.546 24.1708C29.3452 24.3835 30.0515 24.8549 30.5546 25.5113C31.0577 26.1678 31.3292 26.9724 31.3267 27.7994ZM29.5767 27.7994C29.5767 27.403 29.4591 27.0154 29.2388 26.6857C29.0185 26.356 28.7054 26.0991 28.3391 25.9474C27.9728 25.7956 27.5697 25.7559 27.1808 25.8333C26.7919 25.9106 26.4347 26.1016 26.1543 26.3819C25.874 26.6623 25.683 27.0195 25.6057 27.4084C25.5283 27.7973 25.568 28.2004 25.7198 28.5667C25.8715 28.933 26.1284 29.2461 26.4581 29.4664C26.7878 29.6867 27.1754 29.8043 27.5718 29.8043C28.1034 29.8037 28.613 29.5923 28.9888 29.2164C29.3647 28.8406 29.5761 28.331 29.5767 27.7994Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDwelltimeOrange);
export default __webpack_public_path__ + "static/media/Dwell time Orange.7515635eb51d7ba5d45211868b269395.svg";
export { ForwardRef as ReactComponent };